import { isNull } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { RouteComponentProps } from 'react-router';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { PageLoadingDots } from '../../../shared/loading-dots/PageLoadingDots';
import { getIsCalculatingResults, getIsOpening, getNettingEngineResults, getSavedNettingEngineData, openNettingEngineDocumentStarted, resetEngineDataState } from '../store';
import { NettingEngineDocumentAnalysis } from './NettingEngineDocumentAnalysis';
import { NettingEngineResultsWrapper } from '../NettingEngineResultsWrapper';

interface NettingEngineRouteParams {
    documentId?: string;
}

export const NettingEngineDocument: React.FC<RouteComponentProps<NettingEngineRouteParams>> = ({ match: { params } }) => {
    const dispatch = useAppDispatch();
    const isOpening = useAppSelector(getIsOpening);
    const calculatingResults = useAppSelector(getIsCalculatingResults);
    const savedNettingEngineData = useAppSelector(getSavedNettingEngineData);
    const existingResults = useAppSelector(getNettingEngineResults);

    useEffect(() => {
        if (isNull(savedNettingEngineData) && params.documentId) {
            const documentId = parseInt(params.documentId, 10);
            dispatch(openNettingEngineDocumentStarted(documentId, false));
        }
    }, [dispatch, savedNettingEngineData, params]);

    useEffect(() => () => {
        dispatch(resetEngineDataState());
    }, [dispatch]);

    const component = useMemo(() => {
        if (isOpening || calculatingResults) {
            return <PageLoadingDots />;
        }
        if (!isNull(existingResults)) {
            return <NettingEngineResultsWrapper results={existingResults} />;
        }
        return <NettingEngineDocumentAnalysis />;
    }, [isOpening, calculatingResults, existingResults]);

    return component;
};
